<p-toolbar *transloco="let transloco">
  <div class="p-toolbar-group-left flex flex-row items-center gap-2">
    <input
      #uploader
      (change)="this.fileSelected(uploader.files); uploader.value = ''"
      [accept]="this.accept()"
      [disabled]="this.disabled"
      [size]="this.size() || this.sizeLimit"
      hidden
      type="file" />

    <p-button
      (click)="uploader.click()"
      [disabled]="this.disabled"
      label="{{ transloco('select') }}"></p-button>

    @if (!this.fileName) {
      <span>{{ transloco('select_file') }}</span>
    }
    @if (this.fileName) {
      <span>{{ this.fileName }} - {{ this.fileSize | libFilesize: { separator: ',' } }}</span>
    }
  </div>
</p-toolbar>
